/**
 * Download button entrypoint.
 */
import 'components/soft-gate';
